import React from "react"
import '../assets/App.css';
import ImageGallery from 'react-image-gallery';
import PinchZoomPan from "react-responsive-pinch-zoom-pan";
import { Helmet } from "react-helmet";
import { resolvePdfAssetUrl } from "../helper/utils";
import axios from "axios";
import { useLocation } from "react-router-dom";
import queryString from 'query-string'
import './style.css';
import throttle from 'lodash.throttle';
import loader from "../assets/images/loader.gif"
const getDeviceConfig = (width) => {
  if (width < 500) {
    return 'xs';
  } else if (width > 500) {
    return 'sm';
  }
};
const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = React.useState(() => getDeviceConfig(window.innerWidth));

  React.useEffect(() => {
    const calcInnerWidth = throttle(function () {
      setBrkPnt(getDeviceConfig(window.innerWidth))
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return brkPnt;
}

function App() {
  const refImg = React.useRef(null)
  const [data, setData] = React.useState([]);
  const location = useLocation();
  const resId = queryString.parse(location.search).resId;
  const [isThumbnailOpen, setIsThumnailOpen] = React.useState(true);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalpage, setTotalPage] = React.useState(0);

  const getJsonData = async () => {
    await axios.get(`https://cdn-lakshya-app-pdf-private-assets.lakshyakerala.app/${resId}/${resId}.json`)
      .then((res) => {
        setTotalPage(res.data.pages)
        setData(new Array(res.data.pages)
          .fill(0)
          .map((_, i) => ({ original: resolvePdfAssetUrl(resId, "123", "jpg", i + 1), thumbnail: resolvePdfAssetUrl(resId, "123", "jpg", i + 1) })))
      });
  };
  React.useEffect(() => {
    getJsonData()
  }, [resId])

  const breakPoint = useBreakpoint();

  if (data.length === 0) {
    return <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
      <img alt="loader" height={130} width={130} src={loader}></img>
    </div>
  }
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"></meta>
        <title>Pdf Viewer</title>
      </Helmet>
      <ImageGallery
        ref={refImg}
        items={data}
        // onTouchStart={() => {
        //   setIsThumnailOpen(!isThumbnailOpen)
        // }}
        // onTouchEnd={(e) => {

        // }}
        // onDoubleClick={() => (console.log("hit"))} 
        // onTouchMove={() => {
        //   setIsThumnailOpen(true)
        // }}
        onSlide={(currentIndex) => {
          setCurrentPage(currentIndex + 1)
        }}
        flickThreshold={0.2}
        disableThumbnailSwipe={false}
        disableSwipe={true}
        showFullscreenButton={false}
        showPlayButton={false}
        showIndex={false}
        showThumbnails={breakPoint === "xs" ? isThumbnailOpen : false}
        renderItem={(props) => {
          return (
            <div style={{ height: '100vh', width: '100vw', }}>
              <PinchZoomPan
                maxScale={4} zoomButtons={false} position={breakPoint === "xs" ? "top" : "center"}>
                <img alt='img'
                  style={{
                    width: '100%',
                    height: 'auto'
                  }}
                  src={props.original}
                />
              </PinchZoomPan>
            </div>
          )
        }}
      />
      <div style={{ display: "flex", justifyContent: 'center', alignItems: "center", width: "100%" }}>
        <div className={`right-align`} style={{ padding: "5px 10px", opacity: 0.9, backgroundColor: "#E3E3E3", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", top: "20px", }}>
          <span style={{ color: "#828282", fontSize: 14 }}>{currentPage} of {totalpage}</span>
        </div>
      </div>
      {breakPoint === "xs" ? (
        <div style={{ backgroundColor: "#171717", position: "fixed", bottom: 0, width: "100%", height: 44, display: "flex", alignItems: "center", justifyContent: "center", }}>
          <label style={{ color: "#C5C5C5", fontSize: 12 }}>Navigation Pane</label>
          <div style={{ position: "absolute", right: 0, paddingRight: 10 }}>
            <button onClick={() => setIsThumnailOpen(!isThumbnailOpen)} className="nav-button-wrapper">
              {isThumbnailOpen === true ? (
                <i style={{ color: "white" }} class="fas fa-chevron-up"></i>
              ) :
                <i style={{ color: "white" }} class="fas fa-chevron-down"></i>
              }
            </button>
          </div>
        </div>
      ) : null}
    </>

  );
}

export default App;
